import React from 'react';
import _ from '../../utils/_';
import useTranslation from '../../hooks/use-translation/use-translation';
import {H3} from '../typography/typography';
import './review-ratings.scss';

const ReviewRatings = ({value, count, starRatings, readAllUrl}: propTypes) => {
  const progress = _.percentage(count);
  const {t} = useTranslation();

  return (
    <div className="review-ratings">
      <div className="row">
        <div className="col-3" style={{fontSize: '45px'}}>
          {_.formatNumber(value, 1)}
        </div>
        <div className="col-9">
          <H3 style="art">{t('Overall Rating')}</H3>
          <span>{t('Based on {count} reviews', {count})}</span>
        </div>
      </div>

      {starRatings.map((x, i) => (
        <div className="row" key={i}>
          <div className="col-3">
            {x.stars} {t('stars')}
          </div>
          <div className="col-7">
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{width: progress(x.reviews) + '%'}}
                aria-valuenow={progress(x.reviews)}
                aria-valuemin={0}
                aria-valuemax={100}
              ></div>
            </div>
          </div>
          <div className="col-2">{x.reviews}</div>
        </div>
      ))}

      <div className="review-ratings-link">
        <a href={readAllUrl}>{t('Read all customer reviews')}</a>
      </div>
    </div>
  );
};

interface propTypes {
  value: number;
  count: number;
  starRatings: any[];
  readAllUrl: string;
}
export default ReviewRatings;
